import React from "react";
import { Link } from "react-router-dom";
import PolicyLayout from "./PolicyLayout";

function Terms() {
  return (
    <PolicyLayout
      title="Terms of use"
      intro="These rules govern access to the mavormira website. Purchase-specific obligations are set out separately in the Terms of sale."
    >
      <section>
        <h2>Using the site</h2>
        <p>You may browse product information, keep a cart, submit checkout details and use published contact links for genuine personal shopping and support purposes. You must not interfere with site operation, test payment endpoints without authority, introduce harmful code, scrape the catalogue for commercial reuse, or impersonate another buyer.</p>
      </section>

      <section>
        <h2>Information shown online</h2>
        <p>We take reasonable care to connect each item with its name, price, options, photographs, dimensions, materials and care instructions. Hand-finished goods and screens create the variations explained in the <Link to="/product-information">Product information policy</Link>. A clear technical or typographical error may be corrected; a correction does not remove an accrued mandatory consumer remedy.</p>
      </section>

      <section>
        <h2>Links and service continuity</h2>
        <p>Links to hosted payment or email software open services operated by their respective providers. Their availability and technical controls are outside this React interface. We may suspend a page or checkout path to address security, accuracy or maintenance, while preserving obligations already attached to an accepted order.</p>
      </section>

      <section>
        <h2>Messages sent through published contacts</h2>
        <p>You must have authority to send any personal data, image or other material included in a support message. You retain ownership of your material and allow it to be used only as needed to understand, investigate and answer the message or satisfy a legal duty. Unlawful, threatening, malicious or rights-infringing material may be rejected.</p>
      </section>

      <section>
        <h2>Responsibility and mandatory rights</h2>
        <p>Nothing here excludes liability or a consumer, privacy, safety or intellectual-property right that cannot legally be limited. If one provision cannot operate, the remaining provisions continue to the extent they can do so lawfully. No exclusive governing law, court or regulator is selected by these website terms.</p>
      </section>
    </PolicyLayout>
  );
}

export default Terms;
